import deepCopyObject from "../deepCopyObject";
export default function filterHousePlans(
    plans,
    house_type,
    bedrooms,
    bathrooms,
    minimum_plot_size
) {
    let filteredPlans = deepCopyObject(plans);
    bedrooms = bedrooms.map((bedroom) => parseInt(bedroom));
    bathrooms = bathrooms.map((bedroom) => parseInt(bedroom));

    // house_type
    if (house_type != null && house_type.length > 0) {
        filteredPlans = filteredPlans.filter((pln) =>
            house_type.includes(pln.house_type)
        );
    }

    // bedrooms
    if (bedrooms != null && bedrooms.length > 0) {
        filteredPlans = filteredPlans.filter((pln) =>
            bedrooms.includes(pln.bedrooms)
        );
    }

    // bathrooms
    if (bathrooms != null && bathrooms.length > 0) {
        filteredPlans = filteredPlans.filter((pln) =>
            bathrooms.includes(pln.bathrooms)
        );
    }

    // minimum_plot_size
    if (minimum_plot_size != null && minimum_plot_size.length > 0) {
        filteredPlans = filteredPlans.filter((pln) =>
            minimum_plot_size.includes(pln.minimum_plot_size)
        );
    }

    return filteredPlans;
}
